import * as React from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Cookies from "cookies-js";
import { withRouter, Prompt } from 'react-router';

// Our stuff under here
import * as features from "../constants/MembershipFeatures";
import MobileAppBanner from "./common/MobileAppBanner";
import MobileAppDownload from "./common/MobileAppDownload";
import VersionUpdateBanner from "./common/VersionUpdateBanner";
import { HRReadOnlyBanner } from "./common/HRReadOnlyBanner";
import HistoryBinder from "./common/HistoryBinder";
import Notices from "./common/Notices";
import EnsureLoggedIn from "./common/EnsureLoggedIn";
import Header from "./header/Header";
import HeaderLoggedOut from "./header/HeaderLoggedOut";
import Footer from "./common/footer/Footer";
import FooterLoggedOut from "./common/footer/FooterLoggedOut";
import CustomGraphicsBanner from "./dashboard/CustomGraphicsBanner";

import RoutePortal from "./common/RoutePortal";
import RoutePortalLoggedIn from "./common/RoutePortalLoggedIn";
import RouteHP from "./common/RouteHP";
import RouteHPLoggedIn from "./common/RouteHPLoggedIn";
import RouteRX from "./common/RouteRX";
import RouteRXLoggedIn from "./common/RouteRXLoggedIn";
import RoutePortalLoggedInByEXTID from "./common/RoutePortalLoggedInByEXTID";
//import RouteLoggedIn from "./common/RouteLoggedIn";
import RoutesPortalEstimates from './common/RoutesPortalEstimates';
import OurRoute from "./common/OurRoute";
import * as Tools from "../helpers/Tools";
import ChatBot from './chatbot/chatBot'

// Route specific components
import AccountSummary from "./mychart/AccountSummary";
import AdminInfo from "./profile/AdminInfo";
import AdvanceDirectives from "./profile/AdvanceDirectives";
import Allergies from "./profile/Allergies";
import Claims from "./healthplan/Claims";
import Authorizations from "./healthplan/Authorizations";
import Documents from "./healthplan/Documents";
import InvoiceDetails from "./healthplan/InvoiceDetails";
import ClaimDetail from "./healthplan/ClaimDetail";
import Support from "./healthplan/Support";
import ClaimAppeal from "./healthplan/ClaimAppeal";
import SupportNewRequest from "./healthplan/SupportNewRequest";
import AuthorizationDetail from "./healthplan/AuthorizationDetail";
import InvoicesAndPayments from "./healthplan/InvoicesAndPayments";
import PaymentOptions from "./healthplan/PaymentOptions";
import { PaymentFailure } from "./healthplan/PaymentFailure";
import Usage from "./healthplan/Usage";
import Benefits from "./healthplan/Benefits";
import BSWTransfer from "./pharmacy/rxTransfer/BSWTransfer";
import TransferOptions from "./pharmacy/rxTransfer/TransferOptions";
import IdCard from "./healthplan/IdCard";
import Dental from "./healthplan/Dental";
import RequestNewIdCard from "./healthplan/RequestNewIdCard";
import Wellness from "./healthplan/Wellness";
import VirtualCare from "./healthplan/VirtualCare";
import PreferenceSettings from "./healthplan/PreferenceSettings";
import OtherCoverage from "./healthplan/OtherCoverage";
import UpdateOtherCoverage from "./healthplan/UpdateOtherCoverage";
import OtherCoverageDetails from "./healthplan/OtherCoverageDetails";
import HealthPlanNotifications from "./healthplan/HealthPlanNotifications";
import CostEstimator from "./healthplan/CostEstimator";
import CurrentHealthIssues from "./profile/CurrentHealthIssues";
import CurrentMeds from "./profile/CurrentMeds";
import Dashboard from "./dashboard/Dashboard";
import Demographics from "./profile/Demographics";
import ProfileDashboard from "./profile/ProfileDashboard";
import Details from "./providers/Details";
import Disclosures from "./docs/disclosure";
import Estimates from "./mychart/Estimates";
import Estimations from "./profile/Estimations";
import EVisit from "./care/EVisit";
import GetCareLanding from "./care/GetCareLanding";
import HealthSummaryLanding from "./profile/HealthSummaryLanding";
import EVisitLatest from "./care/EVisit_latest";
import EVisitTravel from "./care/EVisitTravel";
import EVisitDependent from "./care/EVisitDependent";
import FAQ from "./docs/faq";
import Privacy from "./docs/privacy";
import CareCompanion from "./carecoach/CareCompanion";
import FavoriteDoctors from "./favproviders/MyProviders";
import FindCare from "./care/FindCare";
import FindCareResults from "./care/FindCareResults";
import FindPharmacy from "./pharmacy/findPharmacy/findPharmacy";
import HealthplanWorkInProgress from "./healthplan/HealthplanWorkInProgress";
import HealthSummary from "./profile/HealthSummary";
import RecordsMedicalFormsLanding from "./profile/RecordsMedicalFormsLanding";
import HelpTutorials from "./settings/HelpTutorials";
import Home from "./home/Home";
import Immunizations from "./profile/Immunizations";
import InPerson from "./care/InPerson";
import Insurance from "./profile/Insurance";
import Coverage from "./mychart/Coverage";
import Letters from "./profile/Letters";
import LinkedAccounts from "./settings/LinkedAccounts";
import LinkedDevices from "./settings/LinkedDevices";
import HpFhirConsents from "./settings/HpFhirConsents";
import Login from "./login/login";
import ForgotUsername from "./login/ForgotUsername";
import ForgotPassword from "./login/ForgotPassword";
import ResetPassword from "./login/ResetPassword";
import LoginSettings from "./settings/LoginSettings";
import MedicalHistory from "./profile/MedicalHistory";
import MedicalTools from "./profile/MedicalTools";
import MessagesAll from "./mychart/MessasgesAll";
import MessagesSend from "./mychart/MessasgesSend";
import MyChartDataTile from "./dashboard/MyChartDataTile";
import MyChartWrapper from "./mychart/MyChartWrapper";
import NavigateParent from "./common/navigateParent";
import NonBSWTransfer from "./pharmacy/rxTransfer/NonBSWTransfer";
import Notifications from "./settings/Notifications";
import OnMyWay from "./mychart/OnMyWay";
import OpenScheduling from "./mychart/OpenScheduling";
import OrderRefill from "./pharmacy/orderRefill/OrderRefill";
import PayAsGuest from "./mychart/PayAsGuest";
import GuestCancelVisit from "./mychart/GuestCancelVisit";
import PersistGateServer from "./common/PersistGateServer";
import Pharmacy from "./pharmacy/Pharmacy";
import ProxyRequest from "./proxyManagement/requestAccess/ProxyRequest";
import PickupDetails from "./pharmacy/PickupDetails";
import PlanofCare from "./profile/PlanofCare";
import Preferences from "./settings/Preferences";
import MarketingEmailOptIn from "./profile/MarketingEmailOptIn";
import PrescriptionDetail from "./pharmacy/rxDetail/PrescriptionDetail";
import ProxyManagement from "./settings/ProxyManagement";
import ProxyMgmtForPharamcyProxies from "./settings/ProxyMgmtForPharamcyProxies";
import ProxyRequestDob from "./proxyManagement/requestAccess/RequestAccessDOB";
import GrantAccessProxyRequest from "./proxyManagement/grantAccess/GrantAccessProxyRequest";
import AcceptProxy from "./proxyManagement/AcceptProxy";
import DeclineProxy from "./proxyManagement/DeclineProxy";
import ProxyTermsV2 from "./proxyManagement/termsModalContent/ProxyTermsV2";
import ProxyMgmtProcessing from "./proxyManagement/ProxyMgmtProcessing";
import InvalidProxyAccess from "./proxyManagement/InvalidProxyAccess";
import FamilyManagement from "./proxyManagement/FamilyManagement";
import Questionnaires from "./profile/Questionnaires";
import ResetTest from "./common/ResetTest";
import RxDetail from "./pharmacy/rxDetail/PrescriptionDetail";
import Schedule from "./appointments/Schedule";
import SchedulingFor from "./appointments/SchedulingFor";
import Scheduling from "./mychart/Scheduling";
import Settings from "./settings/Settings";
import TaxForms from "./healthplan/TaxForms";
import Terms from "./docs/terms";
import TermsAgreement from "./login/TermsAgreement";
import MyConditions from "./mychart/MyConditions";
import TestResults from "./mychart/TestResults";
import TestComponentError from "./common/TestComponentError";
import TestPrerenderError from "./common/TestPrerenderError";
import Thrive from "./thrive/Thrive";
import ThriveForm from "./mychart/ThriveForm";
import VideoVisitConsentForm from "./mychart/VideoVisitConsentForm";
import VideoVisitBHConsentForm from "./mychart/VideoVisitBHConsentForm";
import CustomerService from "./docs/CustomerService";
import ToDos from "./mychart/ToDos";
import UpcomingAppointments from "./mychart/UpcomingAppointments";
import EcheckIn from "./mychart/EcheckIn";
import UpcomingOrders from "./mychart/UpcomingOrders";
import DownloadMyRecord from "./mychart/DownloadMyRecord";
import Audit from "./mychart/Audit";
import Trends from "./mychart/Trends";
import Growth from "./mychart/Growth";
import TrackMyHealth from "./mychart/TrackMyHealth";
import WalletCard from "./mychart/WalletCard";
import ShareEverywhere from "./mychart/ShareEverywhere";
import Procedure from "./mychart/Procedure";
import UpcomingTests from "./profile/UpcomingTests";
import Video from "./care/Video";
import ViewPrescription from "./pharmacy/viewPrescriptions/ViewPrescriptions";
import ViewPrescriptions from "./pharmacy/viewPrescriptions/ViewPrescriptions";
import WhatsNew from "./settings/WhatsNew";
import FluConsent from "./profile/FluConsent";


import { logUI } from "../api/andyliticsApi";
import SystemCrash from "../components/common/SystemCrash";
import SystemOutage from "../components/common/SystemOutage";

import CommunityManage from "./settings/CommunityManage";
import SearchResults from "./home/SearchResults";

import WellBeingJourney from './thrive/WellBeingJourney';
import WellBeingDashboard from './thrive/WellBeingDashboard';

import WellnessReport from "./thrive/WellnessReport";
import WellBeingReport from "./thrive/WellBeingReport";
import WellnessAssessment from "./thrive/WellnessAssessment";
import WellnessAssessmentSuccess from "./thrive/WellnessAssessmentSuccess";
import CriticalUpdateModal from "../components/common/CriticalUpdateModal";
import * as types from "../constants/actionTypes";
import * as prayerFeatureConsts from "../constants/prayerFeatureConstants";
import * as msgs from "../constants/textConstants";
import AALinkForm from '../components/connectedcare/AALinkForm';
import AutoLinkErrorForHP from '../components/healthplan/AutoLinkErrorForHP';
import AccordionMenu from "./common/accordionMenu/Menu";
import Spinner from "./common/spinner";
import FeatureDisabled from "./common/FeatureDisabled";
import ServiceDownBanner from './common/ServiceDownBanner';
import NotAuthorized from "./common/NotAuthorized";
import CaptureInsurance from "./onboarding/CaptureInsurance";
import FamilyMembers from "./onboarding/FamilyMembers";
import ProxySuggestionsSummary from "./onboarding/ProxySuggestionsSummary";
import MammographyScreening from "./onboarding/caregaps/mammogram/MammographyScreening";

import AmbulatoryCareVideoVisit from "../components/care/ambulatorycarevideovisit/AmbulatoryCareVideoVisit";
import VideoVisitComplete from "../components/care/ambulatorycarevideovisit/VideoVisitComplete";
import ErrorPage from "./common/ErrorPage";
import PageNotFound from "./common/PageNotFound";
import VideoVisitDetails from "../components/care/VideoVisitDetails";
import VideoVisitOptions from "../components/care/VideoVisitOptions";
import VideoVisitOptions_PreNew from "../components/care/VideoVisitOptions_PreNew";
import GetStartedVideoVisit from '../components/care/scheduleVideoVisit/GetStarted';
import VideoVisit_ProxySelector from './care/VideoVisit_ProxySelector';
import NonLoggedInVideoVisit from "../components/care/ambulatorycarevideovisit/NonLoggedInVideoVisit";
import PrevisitTest from '../components/care/PreVisitTest';
import EstimatesWrapper from '../components/estimates/estimatesWrapper';
import VaccineEligibility from "../components/covid19Vaccine/VaccineEligibility";
import VaccineEligibilityPreBooster from "../components/covid19Vaccine/VaccineEligibilityPreBooster";
import ScheduleVaccineLanding from "../components/covid19Vaccine/ScheduleVaccineLanding";
import ScheduleVaccineRedirect from "../components/covid19Vaccine/ScheduleVaccineRedirect";
import Covid19VaccineSchedule from "../components/covid19Vaccine/Covid19VaccineSchedule";
import PrayerWall from "./prayerfeature/prayerWall";
import PrayerWallNotAuthorized from "./prayerfeature/PrayerWallNotAuthorized";
import SchedulingComponents from "./schedulingComponents/schedulingComponents";
import Covid19Screener from "../components/covid19Vaccine/screener/Covid19Screener";
import VaccineCredentials from "../components/mychart/VaccineCredentials";
import Paperless from "../components/mychart/Paperless";
import Todo from "../components/mychart/Todo";
import Covid19CareLanding from "../components/covid19Vaccine/Covid19CareLanding";

import { OnboardingLayoutRouteLoggedIn } from "../components/layouts/OnboardingLayoutRoute";
import OnboardingEmailOptIn from "./onboarding/OnboardingEmailOptIn";
import ScheduleMammogram from './appointments/services/mammogram/ScheduleMammogram';
import ScheduleFlu from './appointments/services/fluSchedule/ScheduleFlu';
import ScheduleFluVaccineRedirect from './appointments/services/fluSchedule/ScheduleFluVaccineRedirect';

import CustomDirectScheduling from './appointments/CustomDirectScheduling';
import HeaderMessageBanner from "../components/common/HeaderMessageBanner";
import ScheduleVisitRedirect from "../components/appointments/ScheduleVisitRedirect";

import InHomeLanding from "./inHome/InHomeLanding";
import InHomeWho from "./inHome/InHomeWho";
import InHomeWhoConfirm from "./inHome/InHomeWhoConfirm";
import InHomeWhere from "./inHome/InHomeWhere";
import InHomeInsurance from "./inHome/InHomeInsurance";
import InHomeWhich from "./inHome/InHomeWhich";
import InHomeEligibility from "./inHome/InHomeEligibility";
import InHomeEligibilityCombine from "./inHome/InHomeEligibilityCombine";
import InHomeInEligibility from "./inHome/InHomeInEligibility";
import InHomeCovidSurvey from "./inHome/InHomeCovidSurvey";
import InHomeWhen from "./inHome/InHomeWhen";
import InHomeConfirmDetails from "./inHome/InHomeConfirmDetails";
import InHomeWhatsNext from "./inHome/InHomeWhatsNext";
import InHomeNudge from "./inHome/InHomeNudge";
import MammographyFlow from "./onboarding/caregaps/mammogram/MammographyFlow";
import MammographySummary from "./onboarding/caregaps/mammogram/summary/MammographySummary";
import MammographyUploadDocuments from "./onboarding/caregaps/mammogram/Screen1/MammographyUploadDocuments";
import MammographyConfirmation from "./onboarding/caregaps/mammogram/MammographyConfirmation";
import ScheduleNow from "./appointments/ScheduleNow";
import { Divider } from "./ecosystem";

import PatientStatus from "../components/appointments/PatientStatus ";
import TestComponent from "../components/ecosystem/TestComponent";
import ComponentsDemo from "../components/ecosystem/ComponentsDemo";
import MyChartContainer from "./mychart/MyChartContainer";
import VisitDetails from "./mychart/VisitDetails";
import AfterVisitSummary from "./mychart/AfterVisitSummary";
import ProxyPickerTesting from './common/Proxy/ProxyPickerTesting';
import ProxySelection from './common/Proxy/ProxySelection';
import ScrubbingInLanding from "./scrubbingIn/ScrubbingInLanding";


import A1CScreening from "./onboarding/caregaps/a1c/A1CScreening";
import A1CFlow from "./onboarding/caregaps/a1c/A1CFlow";
import A1CUploadDocuments from "./onboarding/caregaps/a1c/Screen1/A1CUploadDocuments";
import A1CConfirmation from "./onboarding/caregaps/a1c/A1CConfirmation";
import A1CSummary from "./onboarding/caregaps/a1c/summary/A1CSummary";

import AnnualWellnessVisitScreening from "./onboarding/caregaps/annualwellnessvisit/AnnualWellnessVisitScreening";
import AnnualWellnessVisitFlow from "./onboarding/caregaps/annualwellnessvisit/AnnualWellnessVisitFlow";
import AnnualWellnessVisitUploadDocuments from "./onboarding/caregaps/annualwellnessvisit/Screen1/AnnualWellnessVisitUploadDocuments";
import AnnualWellnessVisitConfirmation from "./onboarding/caregaps/annualwellnessvisit/AnnualWellnessVisitConfirmation";
import AnnualWellnessVisitSummary from "./onboarding/caregaps/annualwellnessvisit/summary/AnnualWellnessVisitSummary";
import ProfileLanding from "./profile/ProfileLanding";
import TestProcedureLanding from "./profile/TestProcedureLanding";
import MedicalLanding from "./profile/MedicalLanding";
import ManageAccessLanding from "./settings/ManageAccessLanding";

import ColorectalCancerScreening from "./onboarding/caregaps/colorectalcancer/ColorectalCancerScreening";
import ColorectalCancerFlow from "./onboarding/caregaps/colorectalcancer/ColorectalCancerFlow";
import ColorectalCancerUploadDocuments from "./onboarding/caregaps/colorectalcancer/Screen1/ColorectalCancerUploadDocuments";
import ColorectalCancerConfirmation from "./onboarding/caregaps/colorectalcancer/ColorectalCancerConfirmation";
import ColorectalCancerSummary from "./onboarding/caregaps/colorectalcancer/summary/ColorectalCancerSummary";
import ColorectalCancerSetOne from "./onboarding/caregaps/colorectalcancer/Screen2/ColorectalCancerSetOne";

import BloodPressureScreening from "./onboarding/caregaps/bloodpressure/BloodPressureScreening";
import BloodPressureFlow from "./onboarding/caregaps/bloodpressure/BloodPressureFlow";
import BloodPressureUploadDocuments from "./onboarding/caregaps/bloodpressure/Screen1/BloodPressureUploadDocuments";
import BloodPressureConfirmation from "./onboarding/caregaps/bloodpressure/BloodPressureConfirmation";
import BloodPressureSummary from "./onboarding/caregaps/bloodpressure/summary/BloodPressureSummary";


class AppRoutes extends React.Component {

    static getDerivedStateFromError(error) {
        //debugger;
        return { hasError: true };
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            hadError: false,
            isDataLoaded: false,
            //useOnboardingLayout: false
        };

        this.familyMgmtPaths = ["/onboarding/proxyrequest", "/onboarding/proxyrequestDOB"];  //for these family management routes, we need to use the OnBoradingLayout if we landed on them from the OnBorading Flow
        this.onBoardingLayoutPaths = ["/onboarding/acceptterms", "/onboarding/familymembers", "/onboarding/captureinsurance", "/onboarding/managenotifications", "/onboarding/summary"];  //for these routes, we need to use a different site layout i.e OnBoardingLayout

        this.logHit = this.logHit.bind(this);
        this.getMobileBanner = this.getMobileBanner.bind(this);
        if (typeof window !== "undefined") {
            this.logHit();
        }
        this.criticalUpdateAvailable = false;
        this.isNewAppVersionAvailable = false;
        this.throttle = _.throttle(this.handleResize.bind(this), 150);
        this.previousLocation = props && props.location && props.location.pathname ? props.location.pathname : '';

        // this.setUseOnboardingLayout = this.setUseOnboardingLayout.bind(this);
    }

    componentDidMount() {

        if (this.props.isLoggedIn && this.props.location.pathname === "/login") {
            // Snap off the login page before rednering
            //debugger;
            this.props.history.push("/");
        }

        if (typeof window !== 'undefined') {
            this.handleResize();
            window.addEventListener('resize', this.throttle);
        }

        this.historyUnlisten = this.props.history.listen((location, action) => {
            if (this.previousLocation === '/' && location && location.pathname && location.pathname.indexOf('/familyselection') === -1 &&
                location.pathname !== '/' && this.props.isShowAllUsers) {
                this.props.resetSeeAllView();
            }

            if (location.pathname === this.props.history.location.pathname) {
                window.formChanged = false;
                if (window.isMyChartPage) {
                    this.props.forceReload();
                }
            }
            //console.log("In History Listen path= ", location.pathname);
            this.shouldRouteUseOnboadingLayout();
            this.previousLocation = location && location.pathname ? location.pathname : '';
        });


        this.shouldRouteUseOnboadingLayout();

        //this.unblock = this.props.history.block((location, action) => {
        //    if (window.formChanged || window.componentChanged) {
        //        //debugger;
        //        return "Would you like to leave this page and lose changes?";
        //    }
        //});

        this.updateDataLoaded();
    }

    //Set the breakpoint in the store to use it in application globally. Values need to stay less than and not equal to match grid and css.
    handleResize(event) {
        if (typeof window !== 'undefined') {
            const { screenBreakPoint, setScreenBreakPoint } = this.props;
            let currentScreenBreakPt = '';
            let windowWidth = window.innerWidth;
            if (windowWidth < 375) {
                currentScreenBreakPt = msgs.XS_MOBILE;
            } else if (windowWidth < 480) {
                currentScreenBreakPt = msgs.SM_MOBILE;
            } else if (windowWidth < 768) {
                currentScreenBreakPt = msgs.MD_TABLET;
            } else if (windowWidth < 960) {
                currentScreenBreakPt = msgs.LG_TABLET;
            } else if (windowWidth < 1200) {
                currentScreenBreakPt = msgs.XL_DESKTOP;
            } else if (windowWidth < 1440) {
                currentScreenBreakPt = msgs.XXL_DESKTOP;
            } else {
                currentScreenBreakPt = msgs.XXL_DESKTOP;
            }
            if (currentScreenBreakPt !== screenBreakPoint) {
                setScreenBreakPoint(currentScreenBreakPt);
            }
        }
    }

    componentDidUpdate(prevProps) {

        ////Bug 31395: Back button navigation on Dashboard loads the login page next to Navigation bar.
        //if (this.props.isLoggedIn && this.props.location && this.props.location.pathname === "/login") {
        //    this.props.history.push("/");
        //}

        if (this.props.location.pathname !== prevProps.location.pathname) {
            if (typeof window !== "undefined") {
                window.scrollTo(0, 0);

                this.logHit();
            }
            window.componentChanged = false;
            window.formChanged = false;
        }
        if (this.props.location.pathname !== prevProps.location.pathname) {
            if (this.state.hasError) {
                this.setState({ hasError: false });
            }
        }

        if (this.props.location.pathname !== prevProps.location.pathname) {
            //console.log("ComponenDidUpdate prev path= ", prevProps.location.pathname, "Current path = ", this.props.location.pathname);
            this.shouldRouteUseOnboadingLayout();
        }

        if (this.props.location.pathname.toLowerCase().indexOf('/prayerwall') === 0) {
            this.props.history.replace({ pathname: '/communitySupport', search: this.props.location.search, isActive: true });
        }

        this.updateDataLoaded();
        //console.info(`AppRoutes componentDidUpdate`);
        //try {
        //    QSI.API.run();
        //} catch (e) {
        //    console.warn(`AppRoutes QSI.API.run() failed`,e);
        //}
    }

    componentWillUnmount() {
        window.formChanged = false;
        window.componentChanged = false;
        if (this.state.hasError) {
            this.setState({ hasError: false });
        }
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.throttle);
        }
        if (this.historyUnlisten) {
            this.historyUnlisten();
        }
        //if (this.unblock) {
        //    this.unblock();
        //    this.unblock = null;
        //}
    }

    logHit() {
        try {
            // trackPageView doesn't work, but start/stop does
            //window.appInsights.trackPageView();
            //window.ai.flush();
            //debugger;
            const locpathname = this.props.location.pathname;
            const path = locpathname.replace('/', '.').split('/').join('.').split('-').join('.').split(':').join('.');
            const action = locpathname.replace("/", ".").split('/').length > 0 ? locpathname.replace("/", ".").split('/')[0] : '';
            const actCode = locpathname === "/" ? '.Dashboard' : action;
            logUI("MBHWeb.Event.Route" + actCode, new Date(), this.props.location.href, '', path);
            //debugger;
            window.appInsights.startTrackPage();
            window.appInsights.stopTrackPage();

        }
        catch (e) {
            //debugger;
        }
    }


    componentDidCatch(error, info) {
        //debugger;
        this.setState({ hasError: true });
        let json = { error: error, componentStack: info };
        //logUI("MBHWeb.Event.Route.Exception", new Date(), null, JSON.stringify(json));
        logUI("MBHWeb.UI.MainErrorBoundary.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(error), JSON.stringify(info));
    }

    getMobileBanner = (serverData, isFromMobile, isMobileRedirect) => {
        if (typeof window === "undefined") {
            return null;
        }
        else {
            const NO_REDIRECT = 'noredirect'; // cookie to prevent redirect
            let isAndroid = Tools.isAndroid();
            let isIos = Tools.isIos();
            let isIPad = Tools.isIPad();
            const IS_MOBILE = 'isMobile';
            let isRegistration = Tools.isRegistrationQuery(this.props.location) && this.props.location.pathname === "/terms"; //special case handled here to check the redirection is from registration application for terms.
            const isResetPassword = this.props.location.pathname.toLowerCase() === "/resetpassword";
            const isVideoVisitSharedLink = this.props && this.props.location && this.props.location.pathname && this.props.location.pathname.toLowerCase().indexOf("/videovisit/join") >= 0;
            let showBanner = serverData && serverData.ShowMobileAdvBanner && !Cookies.get(NO_REDIRECT) && (!isIPad && (isAndroid || isIos)) && !isFromMobile && !isMobileRedirect && !isRegistration && !Tools.getItemFromSessionStorage(IS_MOBILE) && !isResetPassword && !isVideoVisitSharedLink; // if noredirect is not stamped and either android or iOS device then showMobileBanner
            // if already skipped and mobilePromptExpirationInDays not exceeded
            if (showBanner) {
                logUI("MBHWeb.Event.ShowMobileBanner", new Date(), this.props.location && this.props.location.pathname, JSON.stringify({ isAndroid: isAndroid, isIos: isIos, isIPad: isIPad, showBanner: showBanner }));
                return (
                    <MobileAppBanner
                        key={showBanner}
                        showBanner={showBanner}
                        mobilePromptExpirationInDays={serverData.mobilePromptExpirationInDays}
                        ssoBaseURL={serverData.ssoBaseURL}
                        isAndroid={isAndroid}
                        isIos={isIos}
                        redirectUrl={this.props.location}
                        careOptions={serverData.careOptions}
                    />);
            }
        }
    }

    updateDataLoaded = () => {
        const isDataLoaded = this.mainContainer && this.mainContainer.offsetHeight > 96;

        if (this.state.isDataLoaded !== isDataLoaded) {
            this.setState({ isDataLoaded });
        }
    }


    shouldRouteUseOnboadingLayout() {
        const { setUseOnboardingLayout } = this.props;
        //console.log("In shouldRouteUser...() method: current path is ", location.pathname, "Current props is ", this.props.useOnboardingLayout);
        let shouldUseOnboardingLayout = this.onBoardingLayoutPaths.some((path) => location.pathname.toUpperCase().includes(path.toUpperCase()));
        let shouldUseOnboardingLayoutForFamilyMgmt = this.familyMgmtPaths.some((path) => location.pathname.toUpperCase().includes(path.toUpperCase()));

        if (shouldUseOnboardingLayout) {
            setUseOnboardingLayout(shouldUseOnboardingLayout);
        }
        else if (shouldUseOnboardingLayoutForFamilyMgmt) {
            //let { useOnboardingLayout: prevUseOnboardingLayout } = this.props;
            /*this.setState((prevState) => {useOnboardingLayout: prevState.useOnboardingLayout ? shouldUseOnboardingLayoutForFamilyMgmt : false },
                () => { return; }//console.log("FamilyMgmt Path is ", location.pathname, "useonblayoutfamilymgmt = ", shouldUseOnboardingLayoutForFamilyMgmt, this.state)
            );*/
            setUseOnboardingLayout(shouldUseOnboardingLayoutForFamilyMgmt);


        }
        else {
            setUseOnboardingLayout(false);
        }
    }



    render() {
        const { formChanged } = window;
        const { isHome, isPharmacy, isServerside, location, MobileOnQueryString, isSwitchingProxy, isProxyUser, isModuleCrash,
            bundle, isActiveFeature_InHomeVaccine, isActiveFeatureAnyone_InHomeVaccine, enableInHomeFeature, EnableProxySuggestion, enableCareCompanion, enableCareGaps } = this.props;
        //if (isSwitchingProxy) {
        //    debugger;
        //}
        const { isLoggedIn, hasMyChart, isMyChartInActive, rxDown, hasPharmacy, currentUserHasPharmacy, serverData, menuItems, appUpdate, applicationVersion,
            normalAppUpdateShow, onLogoutClick, myChartDemographicsComplete, hasAAL, aalDown, providerList, enableThrive365Tile, enablePrayerFeature, /*isActiveFeature_Amity,*/ communitySupportBanned,
            enableProxyRequestV2, enableProxyRXRequestAttestation, insuranceTabText, minAppVersion, siteOutage, appVersion, match, epicEHRDown, isProxySwitchForMychartDeepLink, removeBSWPharmacy,
            inHomeCombineEligibility
        } = this.props;
        const { useOnboardingLayout } = this.props;
        //console.log("In AppRoutes render...path is ", location.pathname, "UseOnboarding is ", useOnboardingLayout);        
        const familyMgmtSidebarProps = { title: "Manage your family's health", subHeading: 'Take care of all their needs from one location.', imageUrl: 'AddFamily.png' };
        const onPharmacy = serverData && serverData.bundle.toLowerCase() === "pharmacy" || location.pathname === '/pharmacy';
        const islocalhost = typeof window !== "undefined" && window.location && window.location.href.toLowerCase().indexOf('localhost') > -1;
        const loadRouteFromPharmacy = (onPharmacy || islocalhost) && typeof currentUserHasPharmacy !== "undefined" && currentUserHasPharmacy ? true : false;
        const isReset = location.pathname === "/reset";
        const AALinkForMobile = () => <AALinkForm className="aa-link-mobile" />;
        let mobileClass = "";
        const isDashboardPage = location.pathname === "/" || location.pathname === "/home";
        const IS_MOBILE = 'isMobile';
        const showAssistanceLink = location.pathname === "/linkedaccounts" || location.pathname === "/linkeddevices" || location.pathname === "/loginsettings";
        const showVersionUpdateBanner = this.isNewAppVersionAvailable && normalAppUpdateShow === true && this.criticalUpdateAvailable === false;
        const showServiceDownBanner = hasMyChart && serverData && serverData.bundle.toLowerCase() === "mybswhealth" && epicEHRDown;
        const videoVisitEnabled = serverData ? serverData.ambulatoryVideoVisitEnabled : false;
        const sameDayVideoVisitScheduleEnabled = serverData && serverData.sameDayVideoVisitScheduleEnabled ? true : false;
        const enableNewVideoVisitFlow = window.serverData && window.serverData.data && window.serverData.data.enableNewVideoVisitFlow;

        let readOnlyPagesArray = window.serverData.data.hrReadOnlyPages.split(",");
        const hasMaintenanceEvent = this.props.maintenanceEvents && this.props.maintenanceEvents.length > 0;
        const isHRReadOnly = hasMaintenanceEvent
            && new Date(this.props.maintenanceEvents[0].Start) < Date.now()
            && new Date(this.props.maintenanceEvents[0].End) > Date.now();
        const readOnlyMessage = hasMaintenanceEvent ?
            (isHRReadOnly ? this.props.maintenanceEvents[0].InProgressMessage : this.props.maintenanceEvents[0].ReminderMessage)
            : "";

        const showGrantProxyAccess = serverData ? serverData.showGrantProxyAccess : false;
        const enabledVirtualDashboard = serverData && serverData.enableVirtualDashboardUpdates ? serverData.enableVirtualDashboardUpdates : false;
        const enablePrevisitHardwareScan = serverData ? serverData.enablePrevisitHardwareScan : false;

        //debugger;
        if (
            minAppVersion &&
            this.minappversion !== minAppVersion) {

            this.minappversion = minAppVersion;
            this.criticalUpdateAvailable = Tools.isNewerVersion(applicationVersion, minAppVersion) ? true : false;
        }

        if (this.state.hasError) {
            return <SystemCrash />;
        }

        if (siteOutage === true) {
            if (isLoggedIn) {
                onLogoutClick();
            }
            return <SystemOutage />;
        }

        //Task 36112: Mobile App: Don't Show Marketing APP download banner if they have mobile=true in query params. We are handling this only for inside mobile app, due to hiding header and footer.
        //if (Tools.isMobileQuery(location)) {

        //}
        const isFromMobile = MobileOnQueryString || Tools.isMobileQuery(location) || Tools.getItemFromSessionStorage(IS_MOBILE); // Tools.isMobileQuery(location); //getting the params from search value of location as we cannot have params at this level for specific comp.    

        //Setting to session storage if we have mobile value.
        if (isFromMobile && !Tools.getItemFromSessionStorage(IS_MOBILE)) {
            Tools.setItemToSessionStorage(IS_MOBILE, true);
        } else if (Tools.isMobileQueryDisabled(location) && Tools.getItemFromSessionStorage(IS_MOBILE)) {
            Tools.clearItemFromSessionStorage(IS_MOBILE);
        }

        const isMobileRedirect = location.pathname === "/download" || (location && location.pathname && location.pathname.toLowerCase().indexOf('/videovisit/launchapp') >= 0);
        if (applicationVersion && appVersion && this.appversion !== appVersion && this.criticalUpdateAvailable === false) {
            this.appversion = appVersion;
            this.isNewAppVersionAvailable = Tools.isNewerVersion(applicationVersion, appVersion) ? true : false;
        }

        //DOWNLOAD APP THAT DIRECTS USER TO CORRESPONDING APP STORE TO DOWNLOAD APP    
        if (isMobileRedirect) {
            let isAndroid = Tools.isAndroid();
            let isIos = Tools.isIos();
            let isIPad = Tools.isIPad();
            this.GOOGLE_PLAY_URL = `${serverData.ssoBaseURL}app_download/android`;
            this.IPHONE_APP_URL = `${serverData.ssoBaseURL}app_download/iphone`;
            if (isIos || isIPad) {
                if (typeof window !== 'undefined')
                    window.location.href = this.IPHONE_APP_URL;
                logUI('MBHWeb.MobileApp.iTunes.Redirect', new Date(), '/iTunesDownload');
                return null;
            }
            else if (isAndroid) {
                if (typeof window !== 'undefined')
                    window.location.href = this.GOOGLE_PLAY_URL;
                logUI('MBHWeb.MobileApp.GooglePlay.Redirect', new Date(), '/GooglePlayDownload');
                return null;
            }
        }

        if (hasPharmacy && (serverData.bundle.toLowerCase() === "pharmacy" || location.pathname.indexOf('/pharmacy') > -1)) {
            mobileClass = isFromMobile ? "bswh-rx bswh-mobile" : "bswh-rx";
        }
        else {
            mobileClass = isFromMobile ? "bswh-mobile" : null;
        }

        //Temp fix to handle multiple redirects from mobile app web view.
        //if (isFromMobile && (location.pathname === "/" || location.pathname === "/login")) {
        //    return <Spinner />;
        //}

        //Temp fix to handle multiple redirects from mobile app web view.
        if (isFromMobile) {
            if (isLoggedIn && (location.pathname === "/" || location.pathname === "/login")) {
                return <Spinner />;
            } else if (!isLoggedIn && (location.pathname === "/login")) {
                //if token is not good, then showing error message if user loading in mobile app web view.
                return <div className={mobileClass}><ErrorPage heading="We're unable to proceed and may need to reload your session." subBannerMsg={"Please try again."} /></div>;
            }
        }

        //Add dynamic route to handle go to direct scheduling if there are ones there or to find care.
        if (isLoggedIn && location.pathname && location.pathname.toLowerCase() === "/redirecttoscheduleappt" && hasMyChart) {
            if (providerList && providerList.length > 0) {
                const enableCustomDirectScheduling = serverData && serverData.enableCustomDirectScheduling ? serverData.enableCustomDirectScheduling : false;
                const directScheduleRoute = enableCustomDirectScheduling ? "/schedule/DirectSchedule" : "/schedulingFor";

                return <Redirect to={directScheduleRoute} />;
            } else {
                return <Redirect to="/findcare" />;
            }
        }

        let hideHeaderPaths = ["/onboarding/acceptterms", "/onboarding/familymembers", "/onboarding/captureinsurance", "/emailoptin", "/onboarding/managenotifications", "/videovisit/join", "/onboarding/summary"];
        let hideFooterPaths = ["/onboarding/acceptterms", "/onboarding/familymembers", "/onboarding/captureinsurance", "/emailoptin", "/onboarding/managenotifications", "/videovisit/join", "/onboarding/summary"];

        let hideHeader = hideHeaderPaths.some((path) => location.pathname.includes(path));
        let hideFooter = hideFooterPaths.some((path) => location.pathname.includes(path));

        let showLoggedInHeader = isLoggedIn && !isReset && !hideHeader && !isFromMobile && location.pathname !== "/login";
        let showLoggedInFooter = !hideFooter && location.pathname !== "/login";

        let enableInHomePages = isLoggedIn ? enableInHomeFeature && (isActiveFeature_InHomeVaccine || !isProxyUser && isActiveFeatureAnyone_InHomeVaccine) : true;

        return (
            <div className={mobileClass} ref={el => this.mainContainer = el}>
                {showLoggedInHeader && hasMyChart && !isSwitchingProxy &&
                    <MyChartContainer
                        mode="demog"
                        id="preLoadMyChart"
                        title=""
                        onIframeLoaded={() => {
                            console.info(`AppRoutes iframeLoaded`);
                            myChartDemographicsComplete();
                            let ifrm = document.getElementById("mychartDataTile");
                            ifrm.parentElement.removeChild(ifrm);
                        }}
                        key={`chartPreLoad`/*this.props.currentUser && this.props.currentUser.displayName*/}
                        containerClass="hidden"
                    />
                }
                <HistoryBinder />
                {!isServerside && <Notices />}
                {!isServerside && <EnsureLoggedIn />}
                {< ChatBot location={location.pathname} />}
                {!useOnboardingLayout &&
                    <>{showLoggedInHeader ?
                        <React.Fragment>
                            <Header
                                serverData={serverData}
                                isDashboardPage={isDashboardPage}
                                showVersionUpdateBanner={showVersionUpdateBanner}
                                showServiceDownBanner={showServiceDownBanner}
                                isMyChartInactivated={isMyChartInActive}
                            >
                                {/*isDashboardPage && !isModuleCrash
                                    ? <CustomGraphicsBanner
                                        versionBannerClass={showVersionUpdateBanner && showServiceDownBanner
                                            ? "version-banner-top" : showServiceDownBanner
                                                ? "service-banner-top" : ""} /> : null*/}
                            </Header>
                            {/*left the silly TST test inplace for easy switching it back to choolsing RefreshAccordionMenu vs AccordionMenu
                         TODO: remove the TST if*/ }
                            <AccordionMenu />
                            {/*showVersionUpdateBanner && showServiceDownBanner ?
                                <VersionUpdateBanner message="Medical records are down for maintenance. However, an update is available for other parts of MyBSWHealth." />
                                : showVersionUpdateBanner && !showServiceDownBanner ? <VersionUpdateBanner message={serverData.versionUpdateMessage} /> :
                                    !showVersionUpdateBanner && showServiceDownBanner ? <ServiceDownBanner className="service-down-banner" message="We’re unable to open some of the features in MyBSWHealth. Please try again later if the issue persists." />
                                        : null
                            */}
                            <HRReadOnlyBanner showBanner={hasMaintenanceEvent && (readOnlyPagesArray.findIndex(page => location.pathname === page) >= 0)} message={readOnlyMessage} />

                        </React.Fragment>
                        :
                        ((location.pathname === "/terms" ||
                            location.pathname === "/faq" ||
                            //location.pathname === "/whatsnew" ||
                            location.pathname === "/disclosures" ||
                            location.pathname === "/payasguest" ||
                            location.pathname === "/privacy" ||
                            location.pathname === "/mycaretasks" ||
                            location.pathname === "/carecoach" ||
                            (location && location.pathname && location.pathname.toLowerCase() === "/visits/guestcancel") ||
                            (location.pathname && location.pathname.includes("/rx/declineproxy")) ||
                            location.pathname === "/download") && !isFromMobile) ||
                            (location.pathname && location.pathname.includes("/proxygrant/decline")) ||
                            (location.pathname && enableProxyRequestV2 && location.pathname.includes("/proxyrequest/decline")) ||
                            location.pathname === "/invalidproxyaccess"
                            ?
                            <HeaderLoggedOut />
                            : ""
                    }</>
                }
                {isSwitchingProxy && !isProxySwitchForMychartDeepLink && <Spinner />}
                <Switch>
                    {/* isActiveFeature_Amity is not needed as prayerWall is open to all users.
                        if the check is needed in the future, it can be done inside the PrayerWall component.
                        doing the check here may fail redirecting to this route from the login screen. 
                    */}
                    {enablePrayerFeature && /*isActiveFeature_Amity && */ <RoutePortalLoggedIn path="/communitySupport" component={isProxyUser || communitySupportBanned ? PrayerWallNotAuthorized : PrayerWall} title="Community Support" />}
                    {enablePrayerFeature && /*isActiveFeature_Amity && */ <RoutePortalLoggedIn path="/prayerWall" component={isProxyUser || communitySupportBanned ? PrayerWallNotAuthorized : PrayerWall} title="Prayer Wall" />}

                    <RoutePortal exact path="/videovisit/join/:roomId?" component={NonLoggedInVideoVisit} title="MyBSWHealth Video Visit" />

                    {
                        videoVisitEnabled &&
                        <RoutePortalLoggedInByEXTID path="/videovisit/:csnId?" component={AmbulatoryCareVideoVisit} title="Video Visit" />

                    }

                    {/**********************  BEGIN  >>>>>>>> ONBOARDING FLOW ROUTES - These are Onboarding Flow Routes. They will load in a different layout i.e. the OnboadrdingLayout */}

                    <OnboardingLayoutRouteLoggedIn path="/onboarding/acceptterms" component={TermsAgreement}
                        useOnboardingLayout={useOnboardingLayout} setUseOnboardingLayout={this.setUseOnboardingLayout}
                        title="Terms and Conditions Acceptance"
                        pageHeading="Terms and Conditions"
                        sidebarProps={{ title: 'Welcome to MyBSWHealth', subHeading: "Let's go through a couple of things to get you started", imageUrl: 'image-terms-of-use.png' }}
                    />
                    <OnboardingLayoutRouteLoggedIn path="/onboarding/captureinsurance" component={CaptureInsurance}
                        useOnboardingLayout={true} setUseOnboardingLayout={this.setUseOnboardingLayout}
                        title="Insurance"
                        pageHeading="Add Your Insurance"
                        sidebarProps={{ title: 'Simplify making appointments', subHeading: "Make sure you're getting the right price for all your healthcare needs. ", imageUrl: 'AddInsurance.png' }}
                    />
                    <OnboardingLayoutRouteLoggedIn path="/onboarding/familymembers" component={FamilyMembers}
                        useOnboardingLayout={useOnboardingLayout} setUseOnboardingLayout={this.setUseOnboardingLayout}
                        title="Family Members"
                        sidebarProps={familyMgmtSidebarProps}
                    />

                    <OnboardingLayoutRouteLoggedIn path="/onboarding/summary" component={ProxySuggestionsSummary}
                        useOnboardingLayout={useOnboardingLayout} setUseOnboardingLayout={this.setUseOnboardingLayout}
                        title="Proxy Suggestions Summary"
                        //pageHeading="Family Members"
                        sidebarProps={familyMgmtSidebarProps}
                    />
                    <OnboardingLayoutRouteLoggedIn path="/onboarding/proxyrequestDOB" component={ProxyRequestDob} blockProxyUsers
                        useOnboardingLayout={useOnboardingLayout} setUseOnboardingLayout={this.setUseOnboardingLayout}
                        title="Request Family Access DOB"
                        sidebarProps={familyMgmtSidebarProps}
                    />
                    <OnboardingLayoutRouteLoggedIn path="/onboarding/proxyrequest" component={ProxyRequest}
                        useOnboardingLayout={useOnboardingLayout} setUseOnboardingLayout={this.setUseOnboardingLayout}
                        title="Request Family Access"
                        sidebarProps={familyMgmtSidebarProps}
                    />
                    <OnboardingLayoutRouteLoggedIn path="/onboarding/managenotifications" component={OnboardingEmailOptIn}
                        useOnboardingLayout={useOnboardingLayout} setUseOnboardingLayout={this.setUseOnboardingLayout}
                        title="Notifications"
                        sidebarProps={{ title: 'Health Care, Your Way', subHeading: "Get the messages that matter most to you.", imageUrl: 'notifications.png' }}
                    />

                    {/**************************  END  >>>>>>>> ONBOARDING LAYOUT ROUTES */}


                    {/*******************  BEGIN >>>>>>>> PROXY/FAMILY MANAGEMENT FLOW ROUTES - These are Family Management Flow Routes. Some of them will load in a different layout i.e. the OnboardingLayout if loaded as
                     part of the Onboarding flow. If not, they will load using the Main Site layout*/}

                    {loadRouteFromPharmacy
                        ? <RouteRXLoggedIn path="/proxymanagement" component={ProxyMgmtForPharamcyProxies} title="Grant or Access Family Accounts" />
                        : <RoutePortalLoggedIn path="/proxymanagement" component={ProxyManagement} title="Grant or Access Family Accounts" />
                    }

                    <RoutePortalLoggedIn path="/proxyrequestDOB" component={hasMyChart || !removeBSWPharmacy ? ProxyRequestDob : NotAuthorized} blockProxyUsers title="Request Family Access DOB" />

                    {showGrantProxyAccess &&
                        <RoutePortalLoggedIn path="/grantaccessProxy" component={hasMyChart || !removeBSWPharmacy ? GrantAccessProxyRequest : NotAuthorized} blockProxyUsers title="Grant Family Access" />
                    }

                    <RoutePortalLoggedIn path="/rx/acceptproxy/:proxyrequestid?" component={AcceptProxy} blockProxyUsers title="Accept Family Access" />

                    {enableProxyRequestV2 && <RoutePortalLoggedIn exact path="/acceptProxyTermsV2/:action?/:proxyRequestId?/:proxySource?/:requestType?/:proxyName?" component={ProxyTermsV2} blockProxyUsers title="Accept Family Access Terms" />}
                    {enableProxyRequestV2 && <RoutePortalLoggedIn exact path="/proxyrequest/accept/:proxyrequestid?/:proxysource?/:proxyname?" component={AcceptProxy} blockProxyUsers title="Accept Request Family Access" />}
                    {enableProxyRequestV2 && <RoutePortal exact path="/proxyrequest/decline/:proxyrequestid?/:proxysource?/:proxyname?" component={DeclineProxy} blockProxyUsers title="Decline Request Family Access" />}
                    {enableProxyRXRequestAttestation && <RoutePortalLoggedIn exact path="/acceptRxProxyTerms/:action?/:proxyRequestId?/:proxySource?/:requestType?/:proxyName?" component={ProxyTermsV2} blockProxyUsers title="Accept Family Access Terms" />}

                    {showGrantProxyAccess && <RoutePortalLoggedIn exact path="/proxygrant/accept/:proxyrequestid?/:proxysource?/:proxyname?" component={AcceptProxy} blockProxyUsers title="Accept Grant Family Access" />}
                    {showGrantProxyAccess && <RoutePortal exact path="/proxygrant/decline/:proxyrequestid?/:proxysource?/:proxyname?" component={DeclineProxy} blockProxyUsers title="Decline Grant Family Access" />}
                    {showGrantProxyAccess && <RoutePortal exact path="/invalidproxyaccess" component={InvalidProxyAccess} blockProxyUsers title="Proxy Expired" />}

                    <RoutePortal path="/proxymgmt/:type?/:source?/:action?/:proxyrequestid?/:proxyname?" component={ProxyMgmtProcessing} title="Family Access" />
                    <RoutePortalLoggedIn path="/proxyrequest" component={ProxyRequest} title="Request Family Access" />
                    <RoutePortal exact path="/rx/declineproxy/:proxyrequestid?/:proxyname?" component={DeclineProxy} title="Decline Family Access" />

                    {/**************************  END >>>>>>>> PROXY/FAMILY MANAGEMENT FLOW ROUTES ************************/}


                    {this.getMobileBanner(serverData, isFromMobile, isMobileRedirect)}

                    {this.criticalUpdateAvailable && <CriticalUpdateModal counterValue={serverData.criticalUpdateCouterValue} />}
                    <RoutePortal exact path="/login" component={Login} serverData={serverData} title="Sign In to MyBSWHealth" />

                    <RoutePortal exact path="/forgotusername" component={ForgotUsername} serverData={serverData} title="Forgot Username" />
                    <RoutePortal exact path="/forgotpassword" component={ForgotPassword} serverData={serverData} title="Forgot Password" />
                    <RoutePortal exact path="/resetpassword" component={ResetPassword} serverData={serverData} title="Reset Password" />
                    <RoutePortal exact path="/faq" component={FAQ} title="Need Help?" />
                    <RoutePortal exact path="/terms" component={Terms} title="Terms and Conditions" />
                    <RoutePortal exact path="/disclosures" component={Disclosures} title="Disclosures" />
                    <RoutePortal exact path="/privacy" component={Privacy} title="Privacy Policy" />
                    <RoutePortalLoggedIn exact path="/carecompanion" component={enableCareCompanion ? CareCompanion : NotAuthorized} title="Care Companion" />
                    <RoutePortal exact path="/videovisitcomplete" component={VideoVisitComplete} title="Video Visit Complete" />
                    <RoutePortal exact path="/download" component={MobileAppDownload} title="Download MyBSWHealth Mobile App" />
                    <RoutePortalLoggedIn exact path="/customerservice" component={CustomerService} serverData={serverData} title="Customer Service" />
                    <RoutePortalLoggedIn exact path="/aalinking" component={AALinkForm} title="BSWQA-DFW CC Linking Form" />
                    <RoutePortalLoggedIn exact path="/hplinkingerror" component={AutoLinkErrorForHP} title="Error in Linking" />
                    <RoutePortal exact path="/payasguest" component={PayAsGuest} serverData={serverData} title="Pay as a guest" />
                    <RoutePortal exact path="/Visits/GuestCancel" component={GuestCancelVisit} serverData={serverData} title="Cancel appointment" />
                    <RoutePortal exact path="/thriveform" component={ThriveForm} serverData={serverData} title="Thrive" />
                    <RoutePortal exact path="/openscheduling" component={OpenScheduling} serverData={serverData} title="Schedule an Appointment" />
                    <Route exact path="/reset" component={NavigateParent} title="" />
                    <RoutePortalLoggedIn exact path="/schedulingcomponents" component={SchedulingComponents} title="Scheduling Components" />
                    <Route exact path="/resettest" component={ResetTest} title="" />
                    <RoutePortalLoggedIn exact path="/" component={Dashboard} title="Home" />
                    <RoutePortalLoggedIn exact path="/home" component={Home} title="Home" />
                    <RoutePortalLoggedIn path="/findcare/vaccine" component={FindCare} title="Find Care" requireXID={true} />
                    <RoutePortalLoggedIn path="/findcareresults" component={FindCareResults} title="Find Care Results" />
                    <RoutePortalLoggedIn path="/findcare" component={FindCare} title="Find Care" />
                    <RoutePortalLoggedIn path="/patientstatus" component={PatientStatus} title="Patient Status" />

                    <RoutePortalLoggedIn exact path="/services/mammogram/schedule/:npi/:scheduleType/:visitTypeId/:departmentId" component={ScheduleMammogram} title="Schedule an Appointment" />
                    <RoutePortalLoggedIn exact path="/services/mammogram/schedule/:npi/:visitTypeId?/:departmentId?/:date?/:time?" component={ScheduleMammogram} title="Schedule an Appointment" />
                    <RoutePortalLoggedIn exact path="/services/mammogram/schedule/:npi/:visitTypeId?/:departmentId?/:date?/:time?/:isFromDotCOM?/:correlationId?" component={ScheduleMammogram} title="Schedule an Appointment" />
                    <RoutePortalLoggedIn exact path="/services/mammogram/schedule/:npi/:visitTypeId?/:departmentId?/:date?/:time?/:isFromDotCOM?/:gacookie?" component={ScheduleMammogram} title="Schedule an Appointment" />
                    <RoutePortalLoggedIn exact path="/services/mammogram/schedule/:npi/:visitTypeId?/:departmentId?/:date?/:time?/:isFromDotCOM?/:correlationId?/:gacookie?" component={ScheduleMammogram} title="Schedule an Appointment" />
                    {/* Flu  */}
                    <RoutePortalLoggedIn exact path="/services/fluvaccine/schedule/:npi/:scheduleType/:visitTypeId/:departmentId" component={ScheduleFlu} title="Schedule an Appointment" />
                    <RoutePortalLoggedIn exact path="/services/fluvaccine/schedule/:npi/:visitTypeId?/:departmentId?/:date?/:time?" component={ScheduleFlu} title="Schedule an Appointment" />
                    <RoutePortalLoggedIn exact path="/services/fluvaccine/schedule/:npi/:visitTypeId?/:departmentId?/:date?/:time?/:isFromDotCOM?/:correlationId?" component={ScheduleFlu} title="Schedule an Appointment" />
                    <RoutePortalLoggedIn exact path="/services/fluvaccine/schedule/:npi/:visitTypeId?/:departmentId?/:date?/:time?/:isFromDotCOM?/:correlationId?/:gacookie?" component={ScheduleFlu} title="Schedule an Appointment" />
                    <RoutePortalLoggedIn exact path="/schedulefluvaccine" component={ScheduleFluVaccineRedirect} title="Schedule Flu Vaccine" />

                    <RoutePortalLoggedIn exact path="/schedule/videovisit/:npi?" component={CustomDirectScheduling} title="Schedule an Appointment" />
                    <RoutePortalLoggedIn exact path="/schedule/:npi?" component={CustomDirectScheduling} title="Schedule an Appointment" />

                    <RoutePortalLoggedIn path="/vaccineeligibility" component={(serverData && serverData.enableCOVID19Booster) ? VaccineEligibility : VaccineEligibilityPreBooster} title="Vaccine Eligibility" />
                    <RoutePortalLoggedIn path="/covid19screener" component={Covid19Screener} title="Covid-19 Screener" />
                    <RoutePortalLoggedIn path="/schedule_covid_vaccine" component={(serverData && serverData.enableCOVID19Booster) ? VaccineEligibility : ScheduleVaccineLanding} title="Schedule COVID-19 Vaccine" />
                    <RoutePortalLoggedIn path="/schedulecovidvaccine" component={ScheduleVaccineRedirect} title="Schedule COVID-19 Vaccine" />
                    <RoutePortalLoggedIn exact path="/covidvaccine/schedule" component={Covid19VaccineSchedule} title="Schedule COVID-19 Vaccine" />
                    {/* <RoutePortalLoggedIn exact path="/schedule/:npi?" component={Schedule} title="Schedule an Appointment" /> */}
                    <RoutePortalLoggedIn exact path="/schedule/:npi/:scheduleType" component={Schedule} title="Schedule an Appointment" />
                    <RoutePortalLoggedIn exact path="/schedule/:npi/:scheduleType/:visitTypeId/:departmentId" component={Schedule} title="Schedule an Appointment" />
                    <RoutePortalLoggedIn exact path="/schedule/:npi/:scheduleType/:departmentId?" component={Schedule} title="Schedule an Appointment" />

                    <RoutePortalLoggedIn exact path="/schedule/:npi/:visitTypeId?/:departmentId?/:date?/:time?" component={Schedule} title="Schedule an Appointment" AllowedOnFeatures={features.AmbulatoryVideoVisit} />
                    <RoutePortalLoggedIn exact path="/schedule/:npi/:visitTypeId?/:departmentId?/:date?/:time?/:step?/:correlationId?/:gacookie?" component={Schedule} title="Schedule an Appointment" AllowedOnFeatures={features.AmbulatoryVideoVisit} />

                    <RoutePortalLoggedIn path="/schedulingFor" component={SchedulingFor} title="Scheduling for..." />
                    <RoutePortalLoggedIn path="/schedulenow" component={ScheduleNow} title="Schedule Now" />

                    <RoutePortalLoggedIn path="/appointments" component={UpcomingAppointments} RequireMyChart title="Appointments" />
                    <RoutePortalLoggedInByEXTID path="/EcheckIn" component={EcheckIn} RequireMyChart title="E-CheckIn" />
                    <RoutePortalLoggedIn path="/todo" component={ToDos} title="Preventive Care" />
                    <RoutePortalLoggedIn path="/healthmaintenance" component={ToDos} title="Preventive Care" />
                    <RoutePortalLoggedIn path="/providers/:npi?" component={Details} />
                    <RoutePortalLoggedIn path="/familymanagement" component={hasMyChart || !removeBSWPharmacy ? FamilyManagement : NotAuthorized} title="Family Management" />



                    <RouteHPLoggedIn exact path="/authorizations" component={aalDown ? FeatureDisabled : Authorizations} title="Authorizations" />
                    <RouteHPLoggedIn exact path="/authorizationdetail" component={aalDown ? FeatureDisabled : AuthorizationDetail} title="Authorization Detail" />
                    <RouteHPLoggedIn exact path="/claims" component={aalDown ? FeatureDisabled : Claims} title="Claims" AllowedOnFeatures={features.InsuranceModule} />
                    <RouteHPLoggedIn exact path="/claimdetail" component={aalDown ? FeatureDisabled : ClaimDetail} title="Claims" />
                    <RouteHPLoggedIn exact path="/claimappeal" render={(props) => (<ClaimAppeal isReadOnly={isHRReadOnly} {...props} />)} title="Claim Appeal" />
                    <RouteHPLoggedIn exact path="/costEstimator" component={aalDown ? FeatureDisabled : CostEstimator} title="Cost Estimator" />
                    <RouteHPLoggedIn exact path="/benefits" component={aalDown ? FeatureDisabled : Benefits} title="Plan and Usage" AllowedOnFeatures={features.InsuranceModule} />
                    <RouteHPLoggedIn exact path="/usage" component={aalDown ? FeatureDisabled : Usage} title={insuranceTabText} AllowedOnFeatures={features.InsuranceModule} />
                    <RouteHPLoggedIn exact path="/idcard" component={aalDown ? FeatureDisabled : IdCard} title="ID Card" />
                    <RouteHPLoggedIn exact path="/dental" component={aalDown ? FeatureDisabled : Dental} title="Dental" />
                    <RouteHPLoggedIn exact path="/requestnewidcard" render={(props) => (<RequestNewIdCard isReadOnly={isHRReadOnly} {...props} />)} aalDown={aalDown} title="Request New ID Card" />
                    <RouteHPLoggedIn exact path="/documents" component={aalDown ? FeatureDisabled : Documents} title="Documents" />
                    <RouteHPLoggedIn exact path="/support" render={(props) => (<Support isReadOnly={isHRReadOnly} {...props} />)} aalDown={aalDown} title="Support" />
                    <RouteHPLoggedIn exact path="/newSupportRequest" render={(props) => (<SupportNewRequest isReadOnly={isHRReadOnly} {...props} />)} title="Support" />
                    <RouteHPLoggedIn exact path="/invoicesAndPayments" component={aalDown ? FeatureDisabled : InvoicesAndPayments} title="Invoices" />
                    <RouteHPLoggedIn exact path="/invoiceDetails" component={aalDown ? FeatureDisabled : InvoiceDetails} title="Invoices" />
                    <RouteHPLoggedIn exact path="/taxForms" component={aalDown ? FeatureDisabled : TaxForms} title="Tax Forms" />
                    <RouteHPLoggedIn exact path="/paymentOptions" component={aalDown ? FeatureDisabled : PaymentOptions} title="Payment Options" />
                    <RouteHPLoggedIn exact path="/paymentFailure" component={aalDown ? FeatureDisabled : PaymentFailure} title="Payment Failure" />
                    <RouteHPLoggedIn exact path="/otherCoverage" component={aalDown ? FeatureDisabled : OtherCoverage} title="Other Coverage" />
                    <RouteHPLoggedIn exact path="/updateOtherCoverage" render={(props) => (<UpdateOtherCoverage isReadOnly={isHRReadOnly} {...props} />)} aalDown={aalDown} title="Update Other Coverage" />
                    <RouteHPLoggedIn exact path="/otherCoverageDetails" component={aalDown ? FeatureDisabled : OtherCoverageDetails} title="Update Other Coverage" />
                    <RouteHPLoggedIn exact path="/Wellness" component={aalDown ? FeatureDisabled : Wellness} title="Wellness" />
                    <RouteHPLoggedIn exact path="/virtualCare" component={aalDown ? FeatureDisabled : VirtualCare} title="Virtual Care" />
                    <RouteHPLoggedIn exact path="/healthplannotifications" component={aalDown ? FeatureDisabled : HealthPlanNotifications} title="Notifications" />
                    <RouteHPLoggedIn exact path="/preferenceSettings" render={(props) => (<PreferenceSettings isReadOnly={isHRReadOnly} {...props} />)} title="Preferences" isReadOnly="isHRReadOnly" />

                    {/*<RouteHPLoggedIn exact path="/requestidcard" component={RequestNewIdCard} title="Card-New" />*/}

                    <RoutePortalLoggedIn path="/inperson" component={InPerson} title="In Person" />
                    <RoutePortalLoggedIn path="/video" component={Video} title="Video Visit" />
                    <RoutePortalLoggedIn path="/onmyway" component={OnMyWay} title="On My Way" />
                    <RoutePortalLoggedIn path="/settings" component={Settings} title="Settings" />

                    <RoutePortalLoggedIn path="/thrive" component={Thrive} blockProxyUsers title="Thrive" />
                    <RoutePortalLoggedIn path="/evisit" component={EVisit} title="eVisit" />
                    <RoutePortalLoggedIn path="/getcare" component={GetCareLanding} title="Schedule & Search" depricatedOn="02/21/2023"/>
                    <RoutePortalLoggedIn path="/schedulesearch" component={GetCareLanding} title="Schedule & Search" />
                    <RoutePortalLoggedIn path="/healthsummarylanding" component={HealthSummaryLanding} RequireMyChart title="Health Summary" />
                    <RoutePortalLoggedIn path="/evisitnow" component={EVisitLatest} title="eVisit" />
                    <RoutePortalLoggedIn path="/evisittravel" component={EVisitTravel} title="eVisit" />
                    <RoutePortalLoggedIn path="/evisitdependent" component={EVisitDependent} title="eVisit" />

                    <RoutePortalLoggedIn path="/videoondemand" component={enabledVirtualDashboard ? PageNotFound : VideoVisitDetails} title="Video On Demand" />
                    <RoutePortalLoggedIn path="/videovisitoptions" component={enabledVirtualDashboard ? enableNewVideoVisitFlow ? VideoVisitOptions : VideoVisitOptions_PreNew : PageNotFound} title="Video Visit" />
                    <RoutePortalLoggedIn path="/videovisitscheduledfor" component={enabledVirtualDashboard ? VideoVisit_ProxySelector : PageNotFound} title="Video Visit" AllowedOnFeatures={features.AmbulatoryVideoVisit + "," + features.SDCVideoVisit} />
                    <RoutePortalLoggedIn path="/aatravel" component={enabledVirtualDashboard ? EVisitTravel : PageNotFound} title="Video Visit" />

                    <RoutePortalLoggedIn path="/schedulevideovisit" component={sameDayVideoVisitScheduleEnabled ? GetStartedVideoVisit : NotAuthorized} title="Schedule Video On Demand" AllowedOnFeatures={features.SDCVideoVisit} />
                    <RoutePortalLoggedIn path="/demographics" component={Demographics} title="Personal Information" />
                    <RoutePortalLoggedIn path="/profiledashboard" component={ProfileDashboard} title="Patient Information" />
                    <RoutePortalLoggedIn path="/personalprofilelanding" component={ProfileLanding} title="Patient Information" />
                    <RoutePortalLoggedIn path="/admininfo" component={AdminInfo} RequireMyChart title="Administrative Information" />
                    <RoutePortalLoggedIn path="/favorites" component={!isProxyUser ? FavoriteDoctors : NotAuthorized} title="Favorite Doctors" />

                    <RoutePortalLoggedIn path="/communityManage" component={CommunityManage} title="Happy Together" />

                    <RoutePortalLoggedIn path="/videovisitconsentform" component={VideoVisitConsentForm} RequireMyChart title="Video Visit Consent Form" />
                    <RoutePortalLoggedIn path="/videovisitbhconsentform" component={VideoVisitBHConsentForm} RequireMyChart title="Video Visit Consent Form" />
                    <RoutePortalLoggedIn path="/currentmeds" component={CurrentMeds} RequireMyChart title="Current Medications" />

                    <RoutePortalLoggedIn path="/immunizations" component={Immunizations} RequireMyChart title="Immunizations" />
                    <RoutePortalLoggedIn path="/allergies" component={Allergies} RequireMyChart title="Allergies" />
                    <RoutePortalLoggedIn path="/currentissues" component={CurrentHealthIssues} RequireMyChart title="Current Health Issues" />
                    <RoutePortalLoggedIn path="/healthsummary" component={HealthSummary} RequireMyChart title="Health Summary" />
                    <RoutePortalLoggedIn path="/recordsmedicalformslanding" component={RecordsMedicalFormsLanding} RequireMyChart title="Records & Medical Forms" />
                    <RoutePortalLoggedIn path="/medicalhistory" component={MedicalHistory} RequireMyChart title="Medical History" />
                    <RoutePortalLoggedIn path="/recordsmedicalformslanding" component={MedicalLanding} title="Medical History" />
                    <RoutePortalLoggedIn path="/insurance" component={Insurance} RequireMyChart title="Insurance" />
                    <RoutePortalLoggedIn path="/coverage" component={Coverage} RequireMyChart title="Coverage" />
                    <RoutePortalLoggedIn path="/medicaltools" component={MedicalTools} RequireMyChart title="Medical Tools" />
                    <RoutePortalLoggedIn path="/planofcare" component={PlanofCare} RequireMyChart title="Plan of Care" />
                    <RoutePortalLoggedIn path="/upcomingtests" component={UpcomingTests} RequireMyChart title="Upcoming Tests" />
                    <RoutePortalLoggedIn path="/testsprocedureslanding" component={TestProcedureLanding} title="Tests" />
                    <RoutePortalLoggedIn path="/estimations" component={Estimations} RequireMyChart title="Estimations" />
                    <RoutePortalLoggedIn path="/letters" component={Letters} RequireMyChart title="Letters" />
                    <RoutePortalLoggedIn path="/directives" component={AdvanceDirectives} RequireMyChart title="Advance Directives" />
                    <RoutePortalLoggedIn path="/medicalrecord" component={DownloadMyRecord} RequireMyChart title="Download My Record" />
                    <RoutePortalLoggedIn path="/audit" component={Audit} RequireMyChart title="Who's Accessed My Record" />
                    <RoutePortalLoggedIn path="/trends" component={Trends} RequireMyChart title="Health Trends" />
                    <RoutePortalLoggedIn path="/growthcharts" component={Growth} RequireMyChart title="Growth Charts" />
                    <RoutePortalLoggedIn path="/questionnaires" component={Questionnaires} RequireMyChart title="Questionnaires" />
                    <RoutePortalLoggedIn path="/trackmyhealth" component={TrackMyHealth} RequireMyChart title="Track My Health" />
                    <RoutePortalLoggedIn path="/walletcard" component={WalletCard} RequireMyChart title="Wallet Card" />
                    <RoutePortalLoggedIn path="/shareeverywhere" component={ShareEverywhere} RequireMyChart title="Share Everywhere" />
                    <RoutePortalLoggedIn path="/notifications" component={Notifications} title="Notifications" />

                    <RoutePortalLoggedIn path="/preferences" component={Preferences} RequireMyChart title="Preferences" />

                    <RoutePortalLoggedIn path="/linkedaccounts" component={LinkedAccounts} title="Linked Accounts and Devices" />
                    <RoutePortalLoggedIn path="/manageaccountslanding" component={ManageAccessLanding} title="Linked Accounts and Devices" />
                    <RoutePortalLoggedIn path="/linkeddevices" component={LinkedDevices} title="Linked Devices" />
                    <RoutePortalLoggedIn path="/hpfhirconsent" component={HpFhirConsents} title="Health Plan FHIR Consent" />
                    <RoutePortalLoggedIn path="/loginsettings" component={LoginSettings} blockProxyUsers title="Login Settings" />

                    <RoutePortalLoggedIn path="/whatsnew" component={PageNotFound} title="What's New" />
                    <RoutePortalLoggedIn path="/help" component={HelpTutorials} title="Help and Tutorials" />

                    <RoutePortalLoggedIn exact path="/scheduling/:workflow?/:rfvId?" component={Procedure} title="Procedure" RequireMyChart />
                    <RoutePortalLoggedInByEXTID exact path="/visit/details" component={VisitDetails} RequireMyChart title="Visit Details" />
                    <RoutePortalLoggedInByEXTID exact path="/visitsummary" component={AfterVisitSummary} RequireMyChart title="AfterVisitSummary" />
                    <RoutePortalLoggedIn path="/mychart/estimates" component={Estimates} RequireMyChart title="Estimates" />
                    <RoutePortalLoggedIn path="/mychart/paperless" component={Paperless} RequireMyChart title="Paperless" />
                    <RoutePortalLoggedIn path="/mychart/CareCoach" component={Todo} RequireMyChart title="To Dos" />
                    <RoutePortalLoggedIn path="/vaccinecredentials" component={VaccineCredentials} RequireMyChart title="Vaccine Credentials" />
                    <RoutePortalLoggedIn exact path="/mychart/upcomingorders" component={UpcomingOrders} RequireMyChart title="Upcoming Orders" />
                    <RoutePortalLoggedIn exact path="/mychart/:mode/:submode" component={MyChartWrapper} RequireMyChart />
                    <RoutePortalLoggedIn exact path="/mychart/:mode" component={MyChartWrapper} />
                    <RoutePortalLoggedIn exact path="/forms/:formName" component={MyChartDataTile} />
                    <RoutePortalLoggedIn exact path="/mychart" component={MyChartDataTile} status="no-Tile" RequireMyChart />

                    <RoutePortalLoggedIn path="/messagesAll" component={MessagesAll} RequireMyChart title="All Messages" />
                    <RoutePortalLoggedIn path="/covid19care" component={Covid19CareLanding} title="COVID-19 Care" />
                    <RoutePortalLoggedIn path="/messagesSend" component={MessagesSend} RequireMyChart title="Send a Message" />
                    <RoutePortalLoggedIn path="/messages" component={MessagesAll} RequireMyChart title="All Messages" />
                    <RoutePortalLoggedIn path="/myconditions" component={MyConditions} RequireMyChart title="My Conditions" />
                    <RoutePortalLoggedIn path="/testresults" component={TestResults} RequireMyChart title="Test Results" />
                    <RoutePortalLoggedIn path="/accountsummary" component={AccountSummary} RequireMyChart title="Account Summary" />
                    <RoutePortalLoggedIn path="/schedulevisit" component={Scheduling} RequireMyChart title="Scheduling" />

                    {/*<!--RoutePortalLoggedIn path="/estimates" component={Estimates} title="Estimates" /-->*/}
                    {/*Pricing Transparency*/}
                    {/*window.serverData.data.enablePricingTransparency && */}{/* <RoutesPortalEstimates/>*/}
                    <RoutePortalLoggedIn exact path="/estimates/:page/:id?" component={EstimatesWrapper} title="Estimates" />;
                    <RoutePortalLoggedIn path="/estimate/:page" component={EstimatesWrapper} title="Estimates" />;


                    <RoutePortalLoggedIn path="/sitesearch" component={SearchResults} title="Search Results" />
                    <RoutePortalLoggedIn path="/healthtips" component={ScrubbingInLanding} title="Scrubbing In" />

                    <RoutePortalLoggedIn path="/wellnessassessment" component={WellnessAssessment} title="Well-being Assessment" />
                    <RoutePortalLoggedIn path="/wellnessassessmentsuccess" component={WellnessAssessmentSuccess} title="Well-being Assessment Success" />
                    <RoutePortalLoggedIn path="/wellnessreport" component={WellnessReport} title="Well-being Report" />
                    <RoutePortalLoggedIn path="/proxypickertesting/:pickerName" component={ProxyPickerTesting} title="proxy testing" />

                    {loadRouteFromPharmacy
                        ? <RouteRXLoggedIn path="/familyselection/:pickerName?" component={ProxySelection} RequireMyChart title="Select Family Member" />
                        : <RoutePortalLoggedIn path="/familyselection/:pickerName?" component={ProxySelection} RequireMyChart title="Select Family Member" />
                    }

                    { /*  Begin Wellness 2.0 Routes */}
                    {enableThrive365Tile && <RoutePortalLoggedIn path="/wellbeingjourney" component={WellBeingJourney} title="Well-being Journey" />}
                    {enableThrive365Tile && <RoutePortalLoggedIn path="/wellbeingdashboard" component={WellBeingDashboard} title="Well-being Dashboard" />}
                    {enableThrive365Tile && <RoutePortalLoggedIn path="/wellbeingreport" component={WellBeingReport} title="Well-being Report" />}
                    {/* End Wellness 2.0 Routes */}

                    {/*  Begin >>>>> CARE GAPS - MAMMOGRAPHY Routes */}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemymammogram" component={MammographyScreening} title="Mammography Screening" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemymammogram/updatehistory" component={MammographyFlow} title="Mammography Screening" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemymammogram/confirmhistory" component={MammographyUploadDocuments} title="Mammography UploadDocuments" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemymammogram/mammosummary" component={MammographySummary} title="Mammography Summary" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemymammogram/confirmation" component={MammographyConfirmation} title="Mammography Confirmation" />}

                    {/*  End  >>>>> CARE GAPS - MAMMOGRAPHY Routes */}

                    {/*  Begin >>>>> CARE GAPS - A1C Routes */}

                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemya1c" component={A1CScreening} title="A1C Screening" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemya1c/updatehistory" component={A1CFlow} title="A1C Screening" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemya1c/confirmhistory" component={A1CUploadDocuments} title="A1C UploadDocuments" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemya1c/a1csummary" component={A1CSummary} title="A1C Summary" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemya1c/confirmation" component={A1CConfirmation} title="A1C Confirmation" />}

                    {/*  End  >>>>> CARE GAPS - A1C Routes */}

                    {/*  Begin >>>>> CARE GAPS - AnnualWellnessVisit Routes */}

                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemyAnnualWellnessVisit" component={AnnualWellnessVisitScreening} title="AnnualWellnessVisit Screening" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemyAnnualWellnessVisit/updatehistory" component={AnnualWellnessVisitFlow} title="AnnualWellnessVisit Screening" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemyAnnualWellnessVisit/confirmhistory" component={AnnualWellnessVisitUploadDocuments} title="AnnualWellnessVisit UploadDocuments" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemyAnnualWellnessVisit/summary" component={AnnualWellnessVisitSummary} title="AnnualWellnessVisit Summary" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemyAnnualWellnessVisit/confirmation" component={AnnualWellnessVisitConfirmation} title="AnnualWellnessVisit Confirmation" />}

                    {/*  End  >>>>> CARE GAPS - AnnualWellnessVisit Routes */}

                    {/*  Begin >>>>> CARE GAPS - ColorectalCancer Routes */}

                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemyColorectalCancerscreening" component={ColorectalCancerScreening} title="Colorectal Cancer Screening" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemyColorectalCancerscreening/updatehistory" component={ColorectalCancerFlow} title="Colorectal Cancer Screening" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemyColorectalCancerscreening/confirmhistory" component={ColorectalCancerUploadDocuments} title="Colorectal Cancer Upload Documents" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemyColorectalCancerscreening/summary" component={ColorectalCancerSummary} title="Colorectal Cancer Summary" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemyColorectalCancerscreening/confirmation" component={ColorectalCancerConfirmation} title="Colorectal Cancer Confirmation" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemyColorectalCancerscreening/letssetupone" component={ColorectalCancerSetOne} title="Colorectal Cancer Setup" />}

                    {/*  End  >>>>> CARE GAPS - ColorectalCancer Routes */}

                    {/* Begin >>>>> CARE GAPS - BloodPressure Routes */}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemyBP" component={BloodPressureScreening} title="Blood Pressure Screening" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemyBP/updatehistory" component={BloodPressureFlow} title="Blood Pressure Screening" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemyBP/confirmhistory" component={BloodPressureUploadDocuments} title="Blood Pressure Upload Documents" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemyBP/summary" component={BloodPressureSummary} title="Blood Pressure Summary" />}
                    {enableCareGaps && <RoutePortalLoggedIn exact path="/schedulemyBP/confirmation" component={BloodPressureConfirmation} title="Blood Pressure Confirmation" />}

                    {/* End >>>>> CARE GAPS - BloodPressure Routes */}


                    {serverData && (serverData.environment === "TST" || serverData.environment === "TST2") &&
                        <RoutePortalLoggedIn path="/testcomponents" component={TestComponent} title="Test Components" />
                    }
                    {serverData && (serverData.environment === "TST" || serverData.environment === "TST2") &&
                        <RoutePortalLoggedIn path="/componentsdemo" component={ComponentsDemo} title="Components Demo" />
                    }

                    <RouteRXLoggedIn path="/rxHome" component={!hasPharmacy && !currentUserHasPharmacy ? NotAuthorized : !rxDown && !removeBSWPharmacy ? Pharmacy : FeatureDisabled} title="BSW Pharmacy" />
                    <RouteRXLoggedIn path="/rxList" component={!hasPharmacy && !currentUserHasPharmacy ? NotAuthorized : !rxDown && !removeBSWPharmacy ? ViewPrescription : FeatureDisabled} title="View Prescriptions" />
                    <RouteRXLoggedIn path="/rxDetail/:storeNumber/:rxNumber/:isExternalRx?" component={!hasPharmacy && !currentUserHasPharmacy ? NotAuthorized : !rxDown ? PrescriptionDetail : FeatureDisabled} title="Prescription Details" />
                    <RouteRXLoggedIn path="/pickupDetails/:storeNumber" component={!hasPharmacy && !currentUserHasPharmacy ? NotAuthorized : !rxDown && !removeBSWPharmacy ? PickupDetails : FeatureDisabled} title="Pick Up Details" />
                    <RouteRXLoggedIn path="/rxTransfer" component={!hasPharmacy && !currentUserHasPharmacy ? NotAuthorized : !rxDown && !removeBSWPharmacy ? TransferOptions : FeatureDisabled} title="Prescription Transfer" />
                    <RouteRXLoggedIn path="/nonBswTransfer" component={!rxDown && !removeBSWPharmacy ? NonBSWTransfer : FeatureDisabled} title="Prescription Transfer" />
                    <RouteRXLoggedIn path="/bswTransfer" component={!hasPharmacy && !currentUserHasPharmacy ? NotAuthorized : !rxDown && !removeBSWPharmacy ? BSWTransfer : FeatureDisabled} title="Prescription Transfer" />
                    <RouteRXLoggedIn path="/rxRefill/:storeNumber?/:rxNumber?" component={!hasPharmacy && !currentUserHasPharmacy ? NotAuthorized : !rxDown && !removeBSWPharmacy ? OrderRefill : FeatureDisabled} />
                    <RouteRXLoggedIn path="/findPharmacy" component={!rxDown && !removeBSWPharmacy ? FindPharmacy : FeatureDisabled} title="Find a Pharmacy" />

                    <RouteRXLoggedIn path="/pharmacy" component={!hasPharmacy && !currentUserHasPharmacy ? NotAuthorized : !rxDown && !removeBSWPharmacy ? Pharmacy : FeatureDisabled} title="BSW Pharmacy" />
                    <RouteRXLoggedIn path="/pharmacyRxList" component={!hasPharmacy && !currentUserHasPharmacy ? NotAuthorized : !rxDown && !removeBSWPharmacy ? ViewPrescriptions : FeatureDisabled} title="View Prescriptions" />
                    <RouteRXLoggedIn exact path="/pharmacyRxDetail" component={!hasPharmacy && !currentUserHasPharmacy ? NotAuthorized : !rxDown && !removeBSWPharmacy ? RxDetail : FeatureDisabled} title="Prescription Details" />
                    <RouteRXLoggedIn path="/pharmacyRxDetail/:storeNumber/:rxNumber/:isExternalRx?" component={!hasPharmacy && !currentUserHasPharmacy ? NotAuthorized && !removeBSWPharmacy : !rxDown ? RxDetail : FeatureDisabled} />
                    <RouteRXLoggedIn path="/pharmacyPickupDetails/:storeNumber" component={!hasPharmacy && !currentUserHasPharmacy ? NotAuthorized : !rxDown && !removeBSWPharmacy ? PickupDetails : FeatureDisabled} title="Pick Up Details" />
                    <RouteRXLoggedIn path="/pharmacyRxTransfer" component={!hasPharmacy && !currentUserHasPharmacy ? NotAuthorized : !rxDown && !removeBSWPharmacy ? TransferOptions : FeatureDisabled} title="Prescription Transfer" />
                    <RouteRXLoggedIn path="/pharmacybswTransfer" component={!hasPharmacy && !currentUserHasPharmacy ? NotAuthorized : !rxDown && !removeBSWPharmacy ? BSWTransfer : FeatureDisabled} title="Prescription Transfer" />
                    <RouteRXLoggedIn path="/pharmacynonBswTransfer" component={!rxDown && !removeBSWPharmacy ? NonBSWTransfer : FeatureDisabled} title="Prescription Transfer" />
                    <RouteRXLoggedIn path="/pharmacyRxRefill/:storeNumber?/:rxNumber?" component={!hasPharmacy && !currentUserHasPharmacy ? NotAuthorized : !rxDown ? OrderRefill : FeatureDisabled} />
                    <RouteRXLoggedIn path="/pharmacyFindPharmacy" component={!rxDown && !removeBSWPharmacy ? FindPharmacy : FeatureDisabled} title="Find a Pharmacy" />

                    <Route path="/TestAppError" component={TestComponentError} />
                    <RoutePortalLoggedIn path="/TestComponentError" component={TestComponentError} />
                    <Route path="/TestPrerenderError" component={TestPrerenderError} />

                    {
                        window.serverData.data.enableFluVaccine &&
                        <RoutePortalLoggedIn path="/fluconsent" component={FluConsent} title="Flu Vaccination Consent" />
                    }

                    <RoutePortalLoggedIn path="/inhomevaccine" component={enableInHomePages ? InHomeLanding : InHomeInEligibility} title="In-Home Vaccine Landing Page" />
                    {enableInHomePages &&
                        <RoutePortalLoggedIn path="/inhomeschedules" component={InHomeWhere} title="In-Home Vaccine Scheduling" />}
                    {enableInHomePages && <RoutePortalLoggedIn path="/inhomeschedule/s2" component={InHomeWhoConfirm} title="In-Home Vaccine Scheduling" />}
                    {enableInHomePages && <RoutePortalLoggedIn path="/inhomeschedule/s3" component={InHomeWho} title="In-Home Vaccine Scheduling" />}
                    {enableInHomePages && <RoutePortalLoggedIn path="/inhomeschedule/s31" component={InHomeInsurance} title="In-Home Vaccine Scheduling" />}
                    {enableInHomePages && <RoutePortalLoggedIn path="/inhomeschedule/s4" component={InHomeWhich} title="In-Home Vaccine Scheduling" />}
                    {enableInHomePages && <RoutePortalLoggedIn path="/inhomeschedule/s41" component={InHomeNudge} title="In-Home Nudge" />}
                    {enableInHomePages && <RoutePortalLoggedIn path="/inhomeschedule/s5" component={inHomeCombineEligibility ? InHomeEligibilityCombine : InHomeEligibility} title="In-Home Vaccine Scheduling" />}
                    {enableInHomePages && <RoutePortalLoggedIn path="/inhomeschedule/s51" component={InHomeCovidSurvey} title="In-Home Covid Survey" />}
                    {enableInHomePages && <RoutePortalLoggedIn path="/inhomeschedule/s6" component={InHomeWhen} title="In-Home Vaccine Scheduling" />}
                    {enableInHomePages && <RoutePortalLoggedIn path="/inhomeschedule/s7" component={InHomeConfirmDetails} title="In-Home Vaccine Scheduling" />}
                    {enableInHomePages && <RoutePortalLoggedIn path="/inhomeschedule/s8" component={InHomeWhatsNext} title="In-Home Vaccine Scheduling" />}


                    <RoutePortalLoggedIn exact path="/requestdcjproxy/:accesstype?/:patientname?/:dcjenrollment?" component={ProxyRequestDob} title="Request Family Access DOB" />
                    <RoutePortal path="/Jason" component={Pharmacy} />
                    <RoutePortal path="/pagenotfound" component={PageNotFound} />
                    <RoutePortal exact path="/previsittest" component={enablePrevisitHardwareScan ? PrevisitTest : PageNotFound} title="MyBSWHealth Previsit Test" />

                    <RoutePortalLoggedIn exact path="/scheduleannualcampaign" component={ScheduleVisitRedirect} title="Schedule Visit" />

                    {isLoggedIn ?
                        (isFromMobile) ? <Redirect to="/pagenotfound" /> : <Redirect to="/" /> : <Redirect to="/login" />}

                </Switch>

                {!useOnboardingLayout &&
                    <>{(isLoggedIn && !isReset && !isFromMobile)
                        ?
                        showLoggedInFooter
                            ? <Footer showAssistanceLink={showAssistanceLink} fixBottom={this.state.isDataLoaded ? "" : "footer-sticky-bottom"} />
                            : <FooterLoggedOut />
                        :
                        ((location.pathname === "/faq" ||
                            location.pathname === "/terms" ||
                            location.pathname === "/disclosures" ||
                            location.pathname === "/forgotusername" ||
                            location.pathname === "/forgotpassword" ||
                            location.pathname === "/resetpassword" ||
                            location.pathname === "/payasguest" ||
                            location.pathname === "/privacy" ||
                            location.pathname === "/mycaretasks" ||
                            location.pathname === "/carecoach" ||
                            location.pathname === "/onboarding/acceptterms" ||
                            location.pathname === "/familymembers" ||
                            (location && location.pathname && location.pathname.toLowerCase() === "/visits/guestcancel") ||
                            (location.pathname && location.pathname.includes("/rx/declineproxy")) ||
                            location.pathname === "/download" ||
                            location.pathname === "/onboarding/captureinsurance") && !isFromMobile) ||
                            (location.pathname && location.pathname.includes("/videovisit/join")) ||
                            (location.pathname && location.pathname.includes("/proxygrant/decline")) ||
                            (location.pathname && enableProxyRequestV2 && location.pathname.includes("/proxyrequest/decline")) ||
                            location.pathname === "/invalidproxyaccess"
                            ? <FooterLoggedOut />
                            : ""
                    }</>
                }
            </div>
        );
    }
}



const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.domain.li,
        providerList: state.directScheduling.providerList,
        canAccessThrive: state.domain.ct,
        isEmployee: state.domain.ie,
        hasMyChart: state.domain.hm,
        isMyChartInActive: state.dashboard.isMyChartInActive,
        hasPharmacy: state.memberships.isActiveFeature_Pharmacy,
        currentUserHasPharmacy: state.domain.cpu && state.domain.cpu.id,
        rxDown: state.inMemory.rxDown,
        aalDown: state.inMemory.aalDown,
        serverData: state.session.serverData,
        menuItems: state.session.serverData ? state.session.serverData.activeMenuItems : null,
        appUpdate: state.common[types.GET_APP_UPDATE],
        applicationVersion: state.session.serverData ? state.session.serverData.applicationVersion : "1.0.0.0",
        normalAppUpdateShow: state.header.normalAppUpdateShow,
        MobileOnQueryString: state.domain.mq,
        isSwitchingProxy: state.memberships.switchingProxyUser,
        isProxyUser: state.domain.ip,
        isModuleCrash: state.common.hideBannerOnCrash,
        enableThrive365Tile: state.session.serverData ? state.session.serverData.enableThrive365Tile : false,
        enableProxyRequestV2: state.session.serverData ? state.session.serverData.enableProxyRequestV2 : false,
        enableProxyRXRequestAttestation: state.session.serverData ? state.session.serverData.enableProxyRXRequestAttestation : false,
        enablePrayerFeature: state.session.serverData && state.session.serverData.enablePrayerFeature,
        //isActiveFeature_Amity: state.memberships.activeFeatures && state.memberships.activeFeatures.amity,
        communitySupportBanned: state.session.userPreferences && state.session.userPreferences[prayerFeatureConsts.COMMUNITY_SUPPORT_BANNED],
        maintenanceEvents: state.session ? state.session.maintenanceEvents : [],
        insuranceTabText: state.memberships.insuranceTabText,
        siteOutage: state.inMemory.siteOutage,
        minAppVersion: state.inMemory.minAppVersion,
        appVersion: state.inMemory.appVersion,
        useOnboardingLayout: state.session.useOnboardingLayout,
        isActiveFeature_InHomeVaccine: state.memberships.isActiveFeature_InHomeVaccine,
        isActiveFeatureAnyone_InHomeVaccine: state.memberships.isActiveFeatureAnyone_InHomeVaccine,
        enableWellnessTiles: state.memberships.isActiveFeature_Wellness,
        enableInHomeFeature: state.session.serverData.enableInHomeFeature,
        EnableProxySuggestion: state.session.serverData && state.session.serverData.EnableProxySuggestion ? true : false,
        screenBreakPoint: state.common.screenBreakPoint,
        enableCareCompanion: state.dashboard?.bffDashboardData?.data?.currentUser?.careCompanion?.isCareCompanion, //state.memberships.enableCareCompanion,
        epicEHRDown: state.common.epicEHRDown,
        enableCareGaps: state.session.serverData && state.session.serverData.enableCareGaps ? true : false,
        isProxySwitchForMychartDeepLink: state.memberships.isProxySwitchForMychartDeepLink ? true : false,
        isShowAllUsers: state.dashboard.isShowAllUsers,
        removeBSWPharmacy: state.session.serverData ? state.session.serverData.removeBSWPharmacy : false,
        inHomeCombineEligibility: state.session.serverData ? state.session.serverData.inHomeCombineEligibility : false,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLogoutClick: () => dispatch({ type: types.LOGOUT, logoutMessage: msgs.UserInitiatedLogoutMessage }),
        forceReload: () => dispatch({ type: types.RELOAD_KEY }),
        setUseOnboardingLayout: (useOnboardingLayout) => dispatch({ type: types.SET_USE_ONBOARDING_LAYOUT, useOnboardingLayout: useOnboardingLayout }),
        setScreenBreakPoint: (screenBreakPoint) => {
            dispatch({ type: types.SET_SCREEN_BREAKPOINT, screenBreakPoint });
        },
        myChartDemographicsComplete: () => dispatch({ type: types.MYCHART_DEMOGRAPHICS_COMPLETE }),
        resetSeeAllView: () => dispatch({ type: types.RESET_DASHBOARD_SEE_ALL_VIEW })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppRoutes));